<template>
	<div id="app">
		<!-- Main Navigation -->
		<main-nav v-if="(isLoggedIn && !isDisplayView) || (!isLoggedIn && isLandingPageView)"></main-nav>

		<!-- Body -->
		<main class="main">
			<transition name="list" mode="out-in">
				<router-view :authenticated="authenticated" :key="$route.fullPath"></router-view>
			</transition>
		</main>

		<!-- Notification Toastr -->
		<notifications group="foo-velocity" position="top right" animation-type="velocity" :speed="500" :duration="3500" :max="4" :ignoreDuplicates="true">
			<template slot="body" slot-scope="props">
				<div class="vue-notification" :class="props.item.type">
					<div class="d-flex justify-content-between align-items-center">
						<div class="notification-title" v-if="props.item.title">{{ props.item.title }}</div>
						<div class="vue-notification-close" @click="props.close">
							<i class="material-icons">close</i>
						</div>
					</div>
					<div v-html="props.item.text"></div>
				</div>
			</template>
		</notifications>

		<!-- Network Identify -->
		<identity-network></identity-network>

		<!-- Cookie Law -->
		<cookie-law
			theme="primary"
			:message="$t('This website makes use of cookies to enhance browsing experience and provide additional functionality')"
			:buttonText="$t('Accept Cookies')"
			:storageName="'cookieConsent'"
			:storageType="'localStorage'">
		</cookie-law>

		<!-- Announcement Notifications -->
		<announcement-notifications v-if="isLoggedIn" />

		<!-- Update App -->
		<update-app v-if="isLoggedIn" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CookieLaw from 'vue-cookie-law';
import AuthService from './auth/AuthService';
import MainNav from './components/MainNav.vue';
import Footer from './components/Footer.vue';
import IdentityNetwork from './components/IdentityNetwork.vue';
import AnnouncementNotifications from './components/AnnouncementNotifications.vue';
import UpdateApp from './components/global/UpdateApp.vue';

const auth = new AuthService();
const {
	authenticated,
	authNotifier,
} = auth;

export default {
	name: 'App',
	components: {
		'main-nav': MainNav,
		'site-footer': Footer,
		IdentityNetwork,
		CookieLaw,
		AnnouncementNotifications,
		UpdateApp,
	},
	data() {
		authNotifier.on('authChange', (authState) => {
			this.authenticated = authState.authenticated;
		});
		return {
			auth,
			authenticated,
			isJoinedRoom: false,
		};
	},
	computed: {
		...mapGetters({
			isSocketConnected: 'isSocketConnected',
			user: 'user',
			isLoggedIn: 'isLoggedIn',
			location: 'location',
		}),
		isDisplayView() {
			const locationName = this.location.to.name;

			const displayViews = [
				'EventDisplay',
				'EventDisplayVoting',
				'EventDisplaySuggestion',
				'EventDisplayNumberSuggestion',
				'EventDisplayPlayback',
				'EventDisplayPlaybackBookmark',
				'EventDisplayNumberVoting',
			];

			return displayViews.includes(locationName);
		},
		isLandingPageView() {
			const locationName = this.location.to.name;

			const displayViews = [
				'LandingPage',
			];

			return displayViews.includes(locationName);
		},
		userLanguage() {
			return this.user.language;
		},
		dropdowns() {
			// eslint-disable-next-line
			const dropdownList = $(document).find('.dropdown-toggle');
			return dropdownList;
		},
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
			setLocale: 'setLocale',
		}),
		fixingShowDropdown() {
			// eslint-disable-next-line
			$(document).find('.dropdown-toggle').dropdown();
		},
		initJoinRoom() {
			if (this.user && !this.isJoinedRoom) {
				this.joinRoom();
			}
		},
		joinRoom() {
			this.isJoinedRoom = true;
			const channel = `mymeet-notifications-user-${this.user.id}`;
			const payload = {
				channel,
			};
			this.$socket.emit('join-system', payload);
		},
		leaveChannel() {
			if (this.user) {
				const channel = `mymeet-notifications-user-${this.user.id}`;
				this.$socket.emit('unsubscribe', channel);
			}
		},
	},
	created() {
		// Fetch user if logged in
		if (this.isLoggedIn && !this.user) {
			this.fetchUser();
		}
	},
	mounted() {
		this.fixingShowDropdown();
	},
	watch: {
		dropdowns() {
			this.fixingShowDropdown();
		},
		userLanguage() {
			const storageLang = localStorage.getItem('language');
			let language = 'no';
			if (this.userLanguage !== undefined) {
				language = this.userLanguage;
			} else {
				language = storageLang !== undefined ? storageLang : 'no';
			}

			this.setLocale(language);
			this.$i18n.locale = language;

			localStorage.setItem('language', language);
		},
		isSocketConnected(isConnected) {
			if (isConnected) {
				this.initJoinRoom();
			} else {
				this.isJoinedRoom = false;
			}
		},
		user() {
			this.initJoinRoom();
		},
	},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
	@import './assets/scss/main.scss';
</style>
